// extracted by mini-css-extract-plugin
var _1 = "PostsListStyles-module__post-container___lcfUZ";
var _2 = "PostsListStyles-module__post-container__input-holder___JlGTS";
var _3 = "PostsListStyles-module__post-container__load-more___TSJkN";
var _4 = "PostsListStyles-module__post-container__post___t4dvp";
var _5 = "PostsListStyles-module__post-container__post-owner___b5i3o";
var _6 = "PostsListStyles-module__post-container___lcfUZ";
var _7 = "PostsListStyles-module__post-container__input-holder___JlGTS";
var _8 = "PostsListStyles-module__post-container__load-more___TSJkN";
var _9 = "PostsListStyles-module__post-container__post___t4dvp";
var _a = "PostsListStyles-module__post-container__post-owner___b5i3o";
export { _1 as "post-container", _2 as "post-container__input-holder", _3 as "post-container__load-more", _4 as "post-container__post", _5 as "post-container__post-owner", _6 as "postContainer", _7 as "postContainerInputHolder", _8 as "postContainerLoadMore", _9 as "postContainerPost", _a as "postContainerPostOwner" }
